import { PageSkeleton } from '@/components/layout/page-skeleton';
import { RouterErrorBoundary } from '@/pages/404/ErrorBoundaryPage';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { queryClient } from './utils/reactQueryClient';
import type { GlobalStore } from './stores/global.store';

export const router = createRouter({
	routeTree,
	context: {
		queryClient,
		globalStore: undefined! as GlobalStore,
	},
	defaultPreload: 'intent',
	defaultPreloadStaleTime: 0,
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultErrorComponent: RouterErrorBoundary,
	defaultPendingComponent: PageSkeleton,
});

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}
